import { useTranslation } from "react-i18next";
import { parseHtml } from "@components/HTMLParser/utils";
import { Notification } from "@components/Notification/Notification";
import { useKnowYourCustomerStore } from "@store/knowYourCustomer/knowYourCustomer";
import { KYCModalActionButtons } from "../KYCModalActionButtons/KYCModalActionButtons";

interface ICloseModalProps {
  variant: "default" | "authentication";
  onClose: () => void;
  onContinue: () => void;
}

export const CloseModal: React.FC<ICloseModalProps> = ({
  variant,
  onClose,
  onContinue,
}) => {
  const { t } = useTranslation();
  const { setVerificationStatus } = useKnowYourCustomerStore();

  return (
    <div className="flex flex-col gap-6">
      <p className="text-gray-900 p-0 text-lg font-semibold">
        {t("KYC.modal.close.title")}
      </p>
      <Notification
        color="red"
        description={
          parseHtml(t(`KYC.modal.close.${variant}.notification`)) as JSX.Element
        }
        className="my-3"
      />
      <KYCModalActionButtons
        onCancel={() => {
          setVerificationStatus(undefined);
          onClose();
        }}
        onSubmit={onContinue}
        cancelButtonText={t("KYC.modal.close.buttons.cancel")}
        submitButtonText={t("KYC.modal.close.buttons.submit")}
      />
    </div>
  );
};
